import moment from "moment";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { useParams } from "react-router-dom";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./printRepair.scss";

const PrintOrder = () => {
    const [totlaPriceWithDiscount, setTotalPriceWithDiscount] = useState(0);

    const { id } = useParams();

    const { data: order, refetch: refetchOrder } = useGetPageQuery("orders/" + id);

    useEffect(() => {
        if (order) {
            setTotalPriceWithDiscount(+order?.total_price - (+order?.discount / 100) * +order?.total_price);
        }
    }, [order]);

    return (
        <>
            <style>
                {`
          @media print {
            @page {
              size: A4 portrait;
            }
            .print-scope {
              width: 210mm;
              height: auto;
              overflow: hidden;
              background: white;
              margin: 0;
              padding: 0;
            }
          }
        `}
            </style>
            {order && (
                <div className="globalWrapper">
                    <div className="printWrapper">
                        <div className="title">
                            <div className="info_left">
                                <h2 contenteditable="true">{order?.store?.title || "Магазину не існує"}</h2>
                                <p contenteditable="true">{order?.store?.address}</p>
                                <p>
                                    Тел.: <span contenteditable="true">{order?.store?.phones}</span>
                                </p>
                                <p>
                                    Режим роботи: <span contenteditable="true">{order?.store?.worktime}</span>
                                </p>
                            </div>

                            <div className="info_right text-right">
                                <h2 contenteditable="true">Гарантійний талон #{order.id}</h2>
                                <div
                                    className="barcode__wrapper text-center"
                                    style={{ width: "fit-content", marginLeft: "auto" }}
                                >
                                    <Barcode
                                        value={order?.ttns?.[0]?.ttn}
                                        height={25}
                                        padding={0}
                                        fontSize={16}
                                        className={"barcode"}
                                    />
                                    <br />
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                        <div className="infos">
                            <div className="info_left">
                                <p>
                                    <b>Клієнт:</b>
                                    <span
                                        contenteditable="true"
                                        data-dl-input-translation="true"
                                    >
                                        ,&nbsp;{order.client_name}
                                    </span>
                                </p>
                                <p>
                                    <b>Примітка:</b> <span contenteditable="true">&nbsp;{order.note}</span>
                                </p>
                            </div>
                            <div className="info_right">
                                <p>
                                    <b>Дата оформлення:</b>&nbsp;{moment(order.created_at).format("DD.MM.YYYY HH:MM")}
                                </p>
                                <p>
                                    <b>Гарантійний термін:</b>&nbsp;
                                    <span contenteditable="true">
                                        30 днів, до {moment(order.created_at).add(30, "d").format("DD.MM.YYYY HH:MM")}
                                    </span>
                                </p>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                        <div className="purchases">
                            <table>
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th>Назва</th>
                                        <th>SN/IMEI</th>
                                        <th>Ціна</th>
                                        <th>Кількість</th>
                                    </tr>
                                    {order.products.map((product, index) => {
                                        return (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{product.title}</td>
                                                <td>{product.imei_sn}</td>
                                                <td>{product.prices.price} грн.</td>
                                                <td>х {product.prices.quantity}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            <h2>
                                Знижка: <span contenteditable="true">{order.discount}</span>%
                            </h2>
                            <h2>
                                До сплати: <span contenteditable="true">{totlaPriceWithDiscount}</span> грн.
                            </h2>
                        </div>

                        <div className="rules">
                            <h3>Умови гарантії</h3>
                            <p>
                                1. Повернення вживаної техніки не можливе згідно Частини 2 Статті 8. "Права споживача у
                                разі придбання ним товару неналежної якості" згідно Закону "Про захист прав споживачів".
                            </p>
                            <p>
                                2. Покупець має право на ремонт або заміну товару, при неможливості проведення ремонту,
                                протягом <span contenteditable="true">30 днів</span> гарантійного терміну, з моменту
                                продажу;
                            </p>
                            <p>
                                3. Покупець зобов'язаний надати правильно заповнений гарантійний талон, що підтверджує
                                покупку товару в нашому магазині;
                            </p>
                            <p>4. Гарантія не поширюється на кабелі живлення, навушники, блоки живлення;</p>
                            <p>5. Гарантія не покриває витрат покупця на доставку пошкодженого товару;</p>
                            <p>
                                6. Магазин не надає товар на заміну того, що знаходиться на обслуговуванні на час
                                ремонту;
                            </p>
                            <p>
                                7. Гарантійний ремонт здійснюється в термін 14 робочих днів. У разі неможливості ремонту
                                і заміни в зазначений термін, за погодженням з клієнтом термін може бути продовжений;
                            </p>
                            <p>8. Обов'язкова наявність повної комплектації товару;</p>
                            <p>
                                9. Магазин не несе відповідальності за будь-які збитки іншого товару, що працює разом з
                                товарами, придбаними в нашому магазині.
                            </p>
                        </div>

                        <div
                            className="rules"
                            style={{ paddingTop: 0 }}
                        >
                            <h3>УМОВИ порушення ГАРАНТІЇ (РЕМОНТ)</h3>
                            <p>1. Відсутність гарантійних пломб або їх пошкодження;</p>
                            <p>2. Будь-які механічні, електромеханічні або хімічні пошкодження приладу;</p>
                            <p>
                                3. Використання приладу не за призначенням або недотримання умов експлуатації,
                                зазначених в інструкції з експлуатації від виробника;
                            </p>
                            <p>
                                4. Заміна будь-яких вузлів, деталей товару, які не передбачені виробником, внесення в
                                конструкцію товару змін та здійснення доробок;
                            </p>
                            <p>
                                5. Пошкодження товару споживачем (включаючи механічні, теплові, електричні,
                                метеорологічні пошкодження);
                            </p>
                            <p>
                                6. Гарантія також не поширюється на нещасні випадки, пожежі, попадання комах, сторонніх
                                рідин, хімічних та інших речовин, затоплення, вібрації, високої температури, коливання
                                напруги в мережі живлення, використання неправильного живлення або вхідної напруги,
                                опромінення, електростатичних розрядів, включаючи блискавку, а також інших видів
                                зовнішнього впливу.
                            </p>
                        </div>

                        <div
                            className="rules"
                            style={{ paddingTop: 0 }}
                        >
                            <h3>
                                ОБОВЯЗКОВІ умови для обміну/повернення пристрою на протязі 14 днів з моменту покупки
                            </h3>
                            <p>
                                1. Згідно зі статтею 9 Закону України "Про захист прав споживачів", обміну або
                                поверненню підлягає тільки новий товар, який не має слідів використання: потертостей,
                                забруднень, тощо;
                            </p>
                            <p>
                                2. Товар повинен бути повернутий у повному комплекті, з ярликом, в своїй оригінальній
                                упаковці, з заводським маркуванням, і супроводжуючими документами;
                            </p>
                            <p>
                                3. Пристрій, що був куплений, як «вживаний» згідно ч.2 статті 8 ЗУ "Про захист прав
                                споживачів" <b>поверненню не підлягає</b>, так як вважається комісійним;
                            </p>
                        </div>

                        <div className="ski_client">
                            <br />
                            <br />
                            Менеджер:&nbsp;_____________________&nbsp;
                            <span contenteditable="true">{order?.user?.name}</span>
                        </div>

                        <div className="ski_compat">
                            З умовами гарантійного обслуговування ознайомлений(а). Своїм підписом підтверджую, <br />
                            що товар був оглянутий та прийнятий належної якості і відповідної комплектації.
                            <br />
                            _____________________&nbsp;<span contenteditable="true"></span>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PrintOrder;
